import * as logging from 'util/Logging';

export default function reportUserFacingLockError(contextString: string): void {
  logging.warn(`User experienced lock error during registration attempt via ${contextString}`);
}
